const doc = [({"en":({"js":({"admin":({"communication":({"templates":({"templates":"Templates"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;